import { createIcon } from "@chakra-ui/react";

export const TickAlt = createIcon({
  displayName: "TickAlt",
  viewBox: "0 0 24 24",
  d: "M19.719 6.812c.364.335.364.878 0 1.182l-9.43 9.43c-.303.363-.846.363-1.181 0L4.25 12.565c-.335-.304-.335-.847 0-1.183a.862.862 0 0 1 1.212 0l4.252 4.254 8.822-8.825c.335-.334.878-.334 1.182 0z",
  defaultProps: {
    "aria-label": "A tick"
  }
});

export default TickAlt;
